import type { Driver } from '@/useDeliveryNote';
import type { ID } from './types';
import type { PaginatorInfo } from './types/paginatorInfo';

export type VehicleType = 'PICKUP' | 'SIX_WHEELS' | 'TEN_WHEELS' | 'TRAILER';
export interface Vehicle {
  id: ID;
  company?: any;
  driver?: Driver;
  license: string;
  licenseProvince: string;
  model: string;
  color: string;
  year: string;
  fuelType: string;
  vehicleType?: VehicleType;
  mile: string;
  maxWidth: string;
  maxLength: string;
  maxHeight: string;
  minWeight: number;
  maxWeight: number;
  avatarUrl: string;
  vehicleWeight: number;
  legalWeight: number;
  reservedOnly?: boolean;
  deliveryNotes?: any[];
  absenceLogs?: any[];
  cashFlows?: any[];
  defaultDriver?: Driver;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  leasedDeliveries?: { data: any[]; paginatorInfo: PaginatorInfo };
  paginatedCashFlows?: { data: any[]; paginatorInfo: PaginatorInfo };
}

export default function useVehicle() {
  const type = ['PICKUP', 'SIX_WHEELS', 'TEN_WHEELS', 'TRAILER'];
  const typeDisplay = ['กระบะ', '6 ล้อ', '10 ล้อ', 'เทรลเลอร์'];
  const typeId = ['1', '2', '3', '4'];
  const icon = ['004', '001', '002', '003'];

  function translate(string: string) {
    const index = type.indexOf(string);
    if (index === -1) return string;
    return typeDisplay[index];
  }

  function vehicleTypeToTravelTimeKey(str: string | VehicleType) {
    if (str === 'PICKUP') return 'pickupTime';
    if (str === 'SIX_WHEELS') return 'sixWheelTime';
    if (str === 'TEN_WHEELS') return 'tenWheelTime';
    return 'trailerTime';
  }
  function vehicleTypeToDeliveryFee(str: string) {
    if (str === 'PICKUP') return 'pickupLeasedCost';
    if (str === 'SIX_WHEELS') return 'sixWheelLeasedCost';
    if (str === 'TEN_WHEELS') return 'tenWheelLeasedCost';
    return 'trailerLeasedCost';
  }

  return {
    type,
    typeDisplay,
    typeId,
    icon,
    translate,
    vehicleTypeToTravelTimeKey,
    vehicleTypeToDeliveryFee,
  };
}
